import { useState } from "react"
import { CheckSquare, Lightbulb, Target, Send, FileText } from "lucide-react"
import { Button } from "../ui/button"
import Card, { CardContent, CardHeader, CardTitle } from "../Card"

export default function AssignmentBlock({ block }) {
  const [userAnswer, setUserAnswer] = useState("")
  const [showHints, setShowHints] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const { content } = block

  const handleSubmit = () => {
    if (userAnswer.trim()) {
      setIsSubmitted(true)
      // Ici vous pouvez ajouter la logique pour sauvegarder la réponse
    }
  }

  return (
    <div className="space-y-6">
      {/* Assignment Header */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <CheckSquare className="w-6 h-6 text-green-600" />
            {block.title}
          </CardTitle>
          {block.description && (
            <p className="text-gray-600">{block.description}</p>
          )}
        </CardHeader>
      </Card>

      {/* Instructions */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5" />
            Instructions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-gray-700 leading-relaxed">
              {typeof content.instructions === 'string' ? content.instructions : (content.instructions?.content || content.instructions || '')}
            </p>
          </div>
        </CardContent>
      </Card>

      {/* Expected Output */}
      {content.expectedOutput && (
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Target className="w-5 h-5" />
              Résultat attendu
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-green-50 border border-green-200 rounded-lg p-4">
              <p className="text-gray-700">{content.expectedOutput}</p>
            </div>
          </CardContent>
        </Card>
      )}

      {/* Hints */}
      {content.hints && content.hints.length > 0 && (
        <Card>
          <CardHeader>
            <div className="flex items-center justify-between">
              <CardTitle className="flex items-center gap-2">
                <Lightbulb className="w-5 h-5" />
                Indices
              </CardTitle>
              <Button
                variant="outline"
                size="sm"
                onClick={() => setShowHints(!showHints)}
              >
                {showHints ? "Masquer" : "Afficher"} les indices
              </Button>
            </div>
          </CardHeader>
          {showHints && (
            <CardContent>
              <div className="space-y-3">
                {content.hints.map((hint, index) => (
                  <div key={index} className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                    <div className="flex items-start gap-2">
                      <span className="bg-yellow-200 text-yellow-800 text-xs font-medium px-2 py-1 rounded-full">
                        Indice {index + 1}
                      </span>
                      <p className="text-gray-700 flex-1">{hint}</p>
                    </div>
                  </div>
                ))}
              </div>
            </CardContent>
          )}
        </Card>
      )}

      {/* Answer Section */}
      <Card>
        <CardHeader>
          <CardTitle>Votre réponse</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <textarea
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value)}
              placeholder="Tapez votre réponse ici..."
              className="w-full h-32 p-3 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              disabled={isSubmitted}
            />
            
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-500">
                {userAnswer.length} caractères
              </div>
              
              {!isSubmitted ? (
                <Button 
                  onClick={handleSubmit}
                  disabled={!userAnswer.trim()}
                  className="bg-green-600 hover:bg-green-700"
                >
                  <Send className="w-4 h-4 mr-2" />
                  Soumettre
                </Button>
              ) : (
                <div className="flex items-center gap-2 text-green-600">
                  <CheckSquare className="w-5 h-5" />
                  <span className="font-medium">Réponse soumise</span>
                </div>
              )}
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Success Message */}
      {isSubmitted && (
        <Card className="border-green-200 bg-green-50">
          <CardContent className="p-4">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                <CheckSquare className="w-5 h-5 text-green-600" />
              </div>
              <div>
                <p className="font-medium text-green-800">Exercice terminé !</p>
                <p className="text-sm text-green-600">Votre réponse a été enregistrée avec succès.</p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  )
}
